import Vue from 'vue'
import Vuex from 'vuex'
// import metaremote from '@/metaremote.js'
import apiclient from '@/apiclient.js'
// import { platform } from 'chart.js'
import moment from 'moment'
import mustache from 'mustache'
import fs from 'fs'
import path from 'path'

Vue.use(Vuex)

function setFieldValue(obj, path, val) {
  let elements=path.split('.');
  let n_elements=elements.length;
  var last=obj;
  for (let i=0; i<(n_elements-1); i++) {
    if (!last[elements[i]]) last[elements[i]]={};
    last=last[elements[i]];
  }
  Vue.set( last, elements[n_elements-1], val);
//  last[elements[n_elements-1]]=val;

  return obj;
}

// Utility per sostituire $User.Id nei filtri
function replaceUserIdInFilters(filters, userid) {
  if (!filters) return filters;
  return filters.map(f => {
    // Ricorsivo anche per filtri annidati (es. childQuery)
    let newF = { ...f };
    if (typeof newF.value === 'string' && newF.value === '$User.Id') {
      newF.value = userid;
    }
    // Se value è array di filtri (caso childQuery)
    if (Array.isArray(newF.value)) {
      newF.value = replaceUserIdInFilters(newF.value, userid);
    }
    return newF;
  });
}

export default new Vuex.Store({
  state: {
    app: 'SalesPaddy 4.0',
    logo: 'app.png',
    busy: false,
    clientConfig: {},      
    isConfigLoaded: false,

    login:false,
    connection:'',
    userid:'',
    overrideKey:'',
    overrideUser:'',
    overrideAccount:'',

    config: { },
    editmode: { },
    romode: { },

    global_state_process:"",
    global_state_verb:"", 
    global_state_pageid:"",
    global_state_defaults: [],

    lookup_field: '',
    lookup_field_value: '',

    // bus message
    message:"",
    message_payload:{},
    messagecnt: 1,

    broadcast_message:"",
    broadcast_message_payload:{},

    // one record at time
    /*
    record_id: "",
    record_data: { },
    record_assoc: { },
    record_state: "",
    */

    records_id: { },
    records_data: { },
    records_assoc: { },
    records_state: { },
    records_list: { },

    query_records: [ ],

    software_states: {},

    database: new Map(),
    calendario : {},

    process_stack: [],
    google_map_loader: undefined,
    myprofile:'',
    editprops:false,
    /*
      NEW: record empty
      EDIT: record in edit mode
      READY: record loaded
    */

    emptyRequiredFields: false,
    advancedFilteringProperties: [],
    approvalInfo: {},
    notificationHistory: [],

    convertInfo: {},
    convertHint: new Map(),
    last_convertHint: {},
    convertSelectedChoices: {},


    fileInfo: {},
    tableindexes: {},

    globalSearch: {},
    configLoadedAt: 0,

    hasNotificationListener: false
  },
  getters: {
    clientConfig: function (state) { return state.clientConfig;},
    isConfigLoaded: function (state) { return state.isConfigLoaded},
    isAdmin: function(state) { return state.myprofile.role=="Admin";},
    appname: function(state) { return state.app },

    connection_id: function(state) { 
      if (state.connection) return state.connection 
      let previous=localStorage.getItem('salespaddy_id');
      if (previous) {
        state.connection=previous;
        state.userid=localStorage.getItem('salespaddy_userid');
        return state.connection
      }
      return; 
    },
    logged: function(state) { return state.login },

    getConfig: (state) =>  (id) => {
      return state.config[id];
    },
    getEditMode: (state) =>  (id) => {
      return state.editmode[id];
    },
    getROMode: (state) =>  (id) => {
      return state.romode[id];
    },
    getProcess: (state) =>  (id) => {
      if (!state.config.processes) return {}
      return state.config.processes.find( (v) => { if (id) return v.id==id; else return v.id=="default"; } );
    },
    getProcessForTable: (state) =>  (table) => {
      if (!state.config.processes) return {}
      return state.config.processes.find( (v) => { if (table) return v.table==table; else return {} } );
    },
    getVerb: () =>  (process, verb) => {
      if (!process.verbs) return {}
      return process.verbs.find( (v) => { if (verb) return v.id==verb; else return v.id=="default"; } );
    },
    getPage: (state) =>  (id) => {
      if (!state.config.pages) return {}
      return state.config.pages.find( (v) => { return v.id==id} );
    },
    getObject: (state) =>  (id) => {
      if (!state.config.objects) return {}
      return state.config.objects.find( (v) => { return v.id==id} );
    },
    getSWState: (state) =>  (name) => {
      return state.software_states[name]
    },
    getRecordsList: (state) =>  (id) => {
      return state.records_list[id];
    },
    getRecordData: function(state) { 
      if (!state.config.processes) {
        console.log('Panico! Non ho i processi')
        return {};
      }
      if (state.process_stack.length > 0) {
        console.log('Ho qualcosa nello stack')
        let s = state.process_stack[state.process_stack.length - 1].processId
        return state.records_data[s]
      }
      return state.records_data[state.global_state_process];
    },
    getRecordState: function(state) { 
      if (!state.config.processes) return '';
      if (state.process_stack.length > 0) {
        let s = state.process_stack[state.process_stack.length - 1].processId // or object id?
        return state.records_state[s]
      }
      return state.records_state[state.global_state_process];
    },
    getRecordId: function(state) {
      if (!state.config.processes) return '';
      return state.records_id[state.global_state_process];
    },
    getRecordAssoc: (state) =>  (id) => {
      return state.records_assoc[id];
    },
    getRecordTable(state, getters) {
      var process = getters.getProcess(state.global_state_process)
      return state.database.get(process.table)
    },
    getProcessStatus: function(state) { return state.process_stack[state.process_stack.length-1] },

    copyProcessStatus: function(state) { return { ...state.process_stack[state.process_stack.length-1] } },

    getProcessDepth: function(state) { return state.process_stack.length },

    isUsed: (state) => (id) => {
      console.log("id ricevuto da isUsed: ", id)
   
      //context.commit('SET_CONFIG', nmPayload);
      if (!state.config.objects) return false;
      
      for (let i = 0; i < state.config.objects.length; i++) {
        const obj = state.config.objects[i];
        
        if (obj.type === "bulmaRows" || obj.type === "bulmaSections") {
          if (obj.data && obj.data.rows && obj.data.rows.find(v => v.id === id)) {
            return true;
          }
        } else if (obj.type === "bulmaSubTab") {
          if (obj.tabs && obj.tabs.find(v => v.id === id)) {
            return true;
          }
        } else if (obj.type === "bulmaContainer") {
          console.log(" trovato container: ", obj)
          if (obj.data && obj.data.cells && obj.data.cells.find(v => v.id === id)) {
            return true;
          }
        }
      }
      
      return false;
    },
    getEditProps: function(state){
      return state.editprops;
    },
    getObjByType: (state) => (type) => {
      //ritorno l'array filtrato in base al type richiesto
      return state.config.objects.filter(obj => obj.type == type);
    },
    getModalButtons(state, getters) {
      let buttons = []


      
      var processStatus = getters.getProcessStatus
      if(processStatus && processStatus.verbId == 'a') {
        if(!getters.getRecordData || !getters.getRecordData.enableApproval__c)
          console.log('MISSING : \ngetRecordData ' + getters.getRecordData + '\n enableApproval__c '+ getters.getRecordData.enableApproval__c)
        if(getters.getRecordData && getters.getRecordData.enableApproval__c
          && !getters.getRecordData.Approval_requested__c) buttons.push({ label: 'Submit', disabled: false })
      } else if(processStatus && processStatus.verbId == 'c') {
        buttons.push({ label: 'Convert', disabled: state.emptyRequiredFields}) 
    //   } if(processStatus.processId=="confermationModal"){
    // console.log("ora lo ritorno")
    //     return [{label: "yes"}, {label: "no"}]//{ label: 'Upload', disabled: state.emptyRequiredFields}
      }else if(processStatus && ( processStatus.verbId == 'close' || processStatus.verbId == 'forward' || processStatus.verbId == 'esterni' || processStatus.verbId == 'assign')) {
        buttons.push({ label: 'Submit', disabled: state.emptyRequiredFields}) 
    //   } if(processStatus.processId=="confermationModal"){
    // console.log("ora lo ritorno")
    //     return [{label: "yes"}, {label: "no"}]//{ label: 'Upload', disabled: state.emptyRequiredFields}
      }
       else if(processStatus && processStatus.processId.indexOf('upload') != -1) { //TODO: if da sistemare, indexof sull'id non va bene
        if(processStatus.verbId == 'n') buttons.push({ label: 'Upload', disabled: state.emptyRequiredFields}) 
      } else if(processStatus && processStatus.processId.indexOf('clone') != -1) { //TODO: if da sistemare, indexof sull'id non va bene
        if(processStatus.verbId == 'n') buttons.push({ label: 'Clone', disabled: state.emptyRequiredFields}) 
      } else buttons.push({ label: 'Save', disabled: state.emptyRequiredFields}) 

      if(getters.canApprove) buttons.push({ label: 'Confirm', disabled: !state.approvalInfo || Object.keys(state.approvalInfo).length == 0 })

      buttons.push({ label: 'Cancel', disabled: false })

      if(processStatus && processStatus.candelete) buttons.push({ label: 'Delete', disabled: false })
      if(processStatus && processStatus.processId && processStatus.processId=="notificationProcess") return[];

      return buttons
    },
    getQueryOperator: (state) => (type) => {
      switch(type) {
        case 'picklist':
          return 'EQ'
        case 'text':
          return 'LIKE'
        case 'date':case 'checkbox':
          return 'NO_STRING_EQ'
      }
    },
    getadvancedFilteringProperties: (state) => (prop) => {
      console.log('getadvancedFilteringProperties')
      for(var f of state.advancedFilteringProperties) {
        if(f.fieldname == prop) return (f.value)
      }
      return ''
    },
    isApprover(state, getters) {
      let approverId = (state.overrideUser && state.overrideUser != null) ? state.overrideUser : state.myprofile.contactId;
      let isApprover = (getters.getRecordData && getters.getRecordData.SalesPaddy_Approver__c && getters.getRecordData.SalesPaddy_Approver__c.includes(approverId));
      let isBackupApprover = (getters.getRecordData && getters.getRecordData.SalesPaddy_BackupApprover__c && getters.getRecordData.SalesPaddy_BackupApprover__c.includes(approverId));

      return (isApprover || isBackupApprover);
    },
    canApprove(state, getters) {
      let approvalReq = (getters.getRecordData && getters.getRecordData.Approval_status__c) ? getters.getRecordData.Approval_status__c.toUpperCase() : '';
      if(getters.isApprover && getters.getRecordData.Approval_requested__c && approvalReq.toUpperCase() == 'PENDING') return true
      return false
    },
    getComponent: (state, getters) => (id, p) => {
      console.log('getComponent', id, p)
      var process
      if(p) process = getters.getProcess(p)
      if(!process) process = getters.getProcess(state.global_state_process)
      console.log('process', process)
      var pageid = getters.getVerb(process, id).pageid
      var initialid = getters.getPage(pageid).initialid
      var data = getters.getObject(initialid).data
      return data
    },
    getNotificationHistory: function(state){
      if(state && state.notificationHistory) return state.notificationHistory;
      return false;
    },
    getFileInfo: function(state){
      return state.fileInfo;
    }
  },
  mutations: {
    SET_LISTENER_FLAG(state, status) {
      state.hasNotificationListener = status;
    },
    SET_CLIENT_CONFIG: function(state, config) {
      state.clientConfig = config;
    },
    SET_CONFIG_LOADED: function(state, status) {
      state.isConfigLoaded = status;
    },
    SET_PROCESS_STATUS_DATA: function(state, payload) { 
      let s=state.process_stack[state.process_stack.length-1];
      console.log('s',s);
      
      Vue.set(s, payload.name, payload.value);
    },
    PUSH_PROCESS_STATUS: function(state, payload) { 
      console.log('PUSH_PROCESS_STATUS', payload)
      state.process_stack.push(payload);
    },
    POP_PROCESS_STATUS: function(state) { 
      console.log('POP_PROCESS_STATUS')
      return state.process_stack.pop();
    },
    SET_FIELD_VALUE: function(state, payload) { 
      if (!state.config.processes) return {};

      if (state.process_stack.length>0) {
        let s=state.process_stack[state.process_stack.length-1];
        console.log('SET_FIELD_VALUE process', s, payload);

        setFieldValue(state.records_data[s.processId], payload.fieldname,  payload.fieldvalue);
      } else {
        console.log('SET_FIELD_VALUE normal', state.global_state_process, payload);
        setFieldValue(state.records_data[state.global_state_process], payload.fieldname,  payload.fieldvalue);
      }
    },
    SET_FIELD_VALUE_CONTEXT(state, payload) {
      console.log('SET_FIELD_VALUE_CONTEXT payload', payload)
      var records = state.records_list[payload.processId].records
      var recordData = state.records_data[payload.processId]
      var recordToUpdate = records.find( r => r.Id == recordData.Id )
      setFieldValue(recordToUpdate, payload.fieldname,  payload.fieldvalue);
    },
    SET_BUSY: function(state, payload) { state.busy=payload },
    SET_OVERRIDEKEY: function(state, payload) { state.overrideKey=payload },
    SET_OVERRIDEUSER: function(state, payload) { state.overrideUser=payload },
    SET_OVERRIDEACCOUNT: function(state, payload) { state.overrideAccount=payload },

    SET_CONNECTION_ID: function(state, payload) { 
      state.connection = payload;
      localStorage.setItem('salespaddy_id', payload);
    },
    SET_USER_ID: function(state, payload) { 
      state.userid = payload;
      localStorage.setItem('salespaddy_userid', payload);
    },
    SET_LOGIN_STATE: function(state, payload) { state.login = payload; },

    SET_GLOBAL_CONFIG: function(state, payload) { 
      state.config=payload;      
      //console.log("payload global config ", state.config.database);
      if (state.config.database) {
        state.config.database.forEach( (d) => {
          var fields=new Map();
          d.fields.forEach( (f) => {
            fields.set( f.name, f);
          })
          state.database.set( d.table, fields );
        })
      }
      state.configLoadedAt = Date.now();
    },
    SET_CONFIG: function(state, payload) { 
      Vue.set(state.config, payload.id, payload.cfg);
    },
    SET_CONFIG_OBJECT: function(state, payload) { 
    
      let i=state.config.objects.findIndex( (obj) => { return obj.id==payload.id; } );
      console.log(i, "index of component to update", i>=0);
      if (i>=0) {
        state.config.objects.splice(i, 1);
        state.config.objects.splice(i, 0, payload );
      } else {
        state.config.objects.push( payload );
 
      }
      
     
    },
    SET_EDITMODE: function(state, payload) { Vue.set(state.editmode, payload.id, payload.editmode); },
    SET_ROMODE: function(state, payload) { Vue.set(state.romode, payload.id, payload.romode); },

   

    // id is the name of the component
    SET_RECORDS_LIST: function(state, payload) { Vue.set(state.records_list, payload.id, payload.data); },

    SET_QUERY_RECORDS: function(state, payload) { state.query_records=payload },

    // id is the name of the component
    SET_RECORDS_ID: function(state, payload) { 
      console.log('SET_RECORDS_ID', payload);
      Vue.set(state.records_id, payload.id, payload.data); },

    INIT_RECORDS_DATA: function(state, id) { 
      console.log('INIT_RECORDS_DATA', id);
      let data={};

      let pconfig=state.config.processes.find( (v) => { if (id) return v.id==id; else return v.id=="default"; } );
      let fields=state.database.get(pconfig.table);
      fields.forEach( (f) => {
        if (!f.readonly) {
          data[f.name]=f.default;
        }
      })

      Vue.set(state.records_data, id, data ); },

    SET_RECORD_ERRORS: function(state, payload) { 
        console.log('SET_RECORD_ERRORS',payload);
    },
    SET_RECORDS_DATA: function(state, payload) { 
      console.log('SET_RECORDS_DATA',payload);
      Vue.set(state.records_data, payload.id, payload.data); },
    SET_RECORDS_STATE: function(state, payload) { 
      console.log('SET_RECORDS_STATE',payload);
      Vue.set(state.records_state, payload.id, payload.state); },
    SET_RECORDS_ASSOC: function(state, payload) { Vue.set(state.records_assoc, payload.id, payload.table, payload.data); },

    SET_GLOBAL_STATE_PROCESS: function(state, payload) { state.global_state_process=payload },
    SET_GLOBAL_STATE_VERB: function(state, payload) { state.global_state_verb=payload },
    SET_GLOBAL_STATE_PAGEID: function(state, payload) { state.global_state_pageid=payload },
    SET_GLOBAL_STATE_DEFAULTS: function(state, payload) { state.global_state_defaults=payload },

    POST_MESSAGE: function(state, payload) { 
      console.log('POST_MESSAGE', payload.message, payload.payload, state.messagecnt)
      state.messagecnt ++
      state.message=payload.message; state.message_payload=payload.payload 
    },
    CLEAR_MESSAGE: function(state) { state.message=""; state.message_payload="" },

    BROADCAST_MESSAGE: function(state, payload) { 
      console.log('BROADCAST_MESSAGE',payload.message)
      state.broadcast_message=payload.message; state.broadcast_message_payload=payload.payload 
    },
    CLEAR_BROADCAST: function(state) { state.broadcast_message=""; state.broadcast_message_payload="" },

    SET_LOOKUP_FIELD: function(state, payload) { state.lookup_field=payload },
    SET_LOOKUP_VALUE: function(state, payload) { state.lookup_field_value=payload },

    SET_GOOGLE_MAP_LOADER: function(state, payload) { state.google_map_loader=payload },
    SET_MYPROFILE: function(state, payload) { state.myprofile=payload },
    
    // REMOVE_RECORDS_DATA: function(state, payload) { 
    //   console.log('REMOVE_RECORDS_DATA',payload);
    //   state.records_data.delete(id)
    //   // Vue.set(state.records_data, payload.id, payload.data);
    // },
    SET_CALENDARIO_STATO(state, { id, chiave, valore }) {
      if (!state.calendario[id]) {
        Vue.set(state.calendario, id, {});
      }
      Vue.set(state.calendario[id], chiave, valore);
    },
  
    UPDATE_CONFIG_OBJECTS(state, updatesArray) {
      // controllo che che `config.objects` sia inizializzato come array
      if (!Array.isArray(state.config.objects)) {
        state.config.objects = [];
      }
  
      updatesArray.forEach(update => {
        const { id, type, data } = update; // Estrai i campi `id`, `type` e `data`
  
        // Cerca un oggetto con il valore `id` corrispondente
        const existingObject = state.config.objects.find(obj => obj.id === id);
  
        if (existingObject) {
          // Se l'oggetto esiste, aggiorna `type` e `data`
          existingObject.type = type;
          existingObject.data = data;
        } else {
          // Se l'oggetto non esiste, aggiungilo all'array
          state.config.objects.push({ id, type, data });
        }
      });
    },
    SET_EDIT_PROPS(state, status){
      state.editprops = status;
    },
    SET_EMPTYREQUIREDFIELDS(state, status) { 
      console.log('SET_EMPTYREQUIREDFIELDS', status)
      state.emptyRequiredFields = status 
    },
    SET_ADVANCEDFILTERINGPROPERTIES(state, payload) {
      console.log('SET_ADVANCEDFILTERINGPROPERTIES', payload)
      var changed = false
      state.advancedFilteringProperties.forEach( f => {
        if(f.fieldname == payload.fieldname) {
          f.value = payload.value
          changed = true
        }
      })
      if(!changed) state.advancedFilteringProperties.push(payload) 
    },
    CLEAR_ADVANCEDFILTERINGPROPERTIES(state) {
      console.log('SET_ADVANCEDFILTERINGPROPERTIES')
      state.advancedFilteringProperties = [] 
    },
    REMOVE_ONE_ADVANCEDFILTERINGPROPERTIES(state, payload) {
      console.log('REMOVE_ONE_ADVANCEDFILTERINGPROPERTIES')
      var index = -1
      state.advancedFilteringProperties.forEach( (f, i) => {
        if(f.fieldname == payload.fieldname) index = i
      })
      state.advancedFilteringProperties.splice(index, 1)
    },
    SET_APPROVAL_INFO(state, payload) { state.approvalInfo = payload },
    CLEAR_APPROVAL_INFO(state) { state.approvalInfo = {} },

    SET_CONVERT_INFO(state, payload) { state.convertInfo[payload.field] = payload.value },
    CLEAR_CONVERT_INFO(state) { state.convertInfo = {} },
    SET_CONVERT_HINT(state, payload) { 
      console.log('SET_CONVERT_HINT', payload)
      if(!state.convertHint.has(payload.id)) {
        state.convertHint.set(payload.id, new Map([ [payload.type, { field: payload.field, value: payload.value }] ]))
      } else {
        var fields = state.convertHint.get(payload.id)
        if(fields.has(payload.type)) {
          fields.get(payload.type).value = payload.value
        } else fields.set(payload.type, { field: payload.field, value: payload.value })
      }
      state.last_convertHint = { field: payload.field, value: payload.value }
    },
    CLEAR_CONVERT_HINT(state) { state.convertHint = new Map() },
    SET_CONVERT_SELECTEDCHOICES(state, payload) { state.convertSelectedChoices[payload.field] = payload.value },
    CLEAR_CONVERT_SELECTEDCHOICES(state) { state.convertSelectedChoices = {} },
    PUSH_NOTIFICATION: function (state, payload) {
      if (!state.notificationHistory) {
        state.notificationHistory = [];
      }

      const isDuplicate = state.notificationHistory.some(item => item.Id === payload.Id);

      if (!isDuplicate) {
        state.notificationHistory.unshift(payload);
      } else {
        console.log("Duplicate notification blocked:", payload.Id);
      }
    },
    SET_NOTIFICATIONS: function(state, payload) { 
      // Vue.set(state.config, payload.id, payload.);
      console.log("--> SET_NOTIFICATIONS --> payload: ", payload);
      state.notificationHistory=payload;
    },
    SET_FILE_INFO: function(state, payload) {
      console.log("--> SET_FILE_INFO --> payload: ", payload);
      state.fileInfo=payload;
    },
    SET_TABLE_INDEX: function(state, payload) { 
      if(!state.tableindexes[payload.table]){
        console.log("state.tableindexes[payload.table] not initialized");
        state.tableindexes[payload.table] = {page:"", list:""}
      }
   
      if(payload.page) state.tableindexes[payload.table].page = payload.page;
      if(payload.list) state.tableindexes[payload.table].list = payload.list;
    },
    SET_GLOBALSEARCH(state, payload) { state.globalSearch[payload.field] = payload.value }
  },
  modules: {
  },
  actions: {
    fetchClientConfig: async function (context, payload) {
      try {
        const config = await apiclient.fetchClientSettings();
        console.log("config: ", config);
        
        context.commit('SET_CLIENT_CONFIG', config);
        context.commit('SET_CONFIG_LOADED', true);
      } catch (err) {
        console.log('fetchClientConfig failed', payload);
        console.log('fetchClientConfig failed', err);
        context.commit('SET_CONFIG_LOADED', true);
        console.log(err);
        return false;
      }
    },
    checkRequiredFields: function(context) {
      console.log('--> checkRequiredFields')
      var process = context.getters.getProcessStatus
      let table 
      // if(process && process.table) table = context.state.database.get(process.table);
      if(process.verbId == 'c') {
        table = new Map()
        var verb = context.getters.getVerb( context.getters.getProcess(process.processId), 'c' )
        var objectData = context.getters.getObject(verb.pageid).data
        for(var o of objectData.objects) {
          var stato = context.state.convertSelectedChoices[o.name]
          if(stato == 'create') o.create_fields.forEach( cf => { table.set(cf.name, cf) })
          else if(stato == 'existing') o.existing_fields.forEach( cf => { table.set(cf.name, cf) })
        }
      } else if(process && process.table) table = context.state.database.get(process.table);

      if(table) {
        var record = context.getters.getRecordData
        var tmp = false
        for(var f of table.keys()) {
          if(table.get(f).required && !record[f]) {
            console.log(f, record[f])
            context.commit('SET_EMPTYREQUIREDFIELDS', true)
            tmp = true
            break
          }
        }
        if(!tmp) context.commit('SET_EMPTYREQUIREDFIELDS', false)
      } else context.commit('SET_EMPTYREQUIREDFIELDS', false)
    },
    createProperties: function(context, payload) {
      let prop={};
      let thetable = context.state.database.get(payload.table);
      
      let data = payload.data
      for (let p in data) {
        if (typeof data[p] != 'object') {
          let f=thetable.get(p);
          if (f && !f.readonly) {
            prop[p]=data[p];
          }
        }
      }
      return prop;
    },
    setDefaults: function(context, payload) {
      console.log('setDefaults payload', payload)
      var defaults = []

      let s=context.getters.getProcessStatus;
      if (s && s.defaults) defaults = s.defaults
      else if(context.state.global_state_defaults.length > 0) {
        defaults = context.state.global_state_defaults
      }
      console.log('getProcessStatus for defaults', defaults);

      if(defaults.length > 0) {
        defaults.forEach( (d) => {
          console.log("default", d);
          if (d.default) payload.record[d.fieldname] = d.default
          if (d.previous) {
            let s = context.state.global_state_process;  
            let r = context.state.records_data[s]        

            payload.record[d.fieldname] = r[d.previous] 
          }
        })
        return payload.record
      }
    },
    googleMapLoader: async function(context, payload ) {
      if (!context.state.google_map_loader) {
        console.log('store: loading loader');
        
        let loader = new payload.loader({ apiKey: payload.apiKey, version: "beta", });
        // let loader = new payload.loader({ apiKey: payload.apiKey, version: "weekly", });
        context.commit('SET_GOOGLE_MAP_LOADER', loader);
      }
      return context.state.google_map_loader;
    },
    ssologin: async function(context) {
      console.log('action login');
      
      context.commit('SET_CONNECTION_ID', '');
      context.commit('SET_LOGIN_STATE', false);

      let resp=await apiclient.ssologin();
      return resp;
    },
    myprofile: async function(context) {
      console.log("in myprofile context.getters.connection_id: ", context.getters.connection_id);
      
      let resp=await apiclient.myprofile(context.getters.connection_id);
      console.log("myprofile", resp.myprofile);
      context.commit('SET_MYPROFILE', resp.myprofile);

      return resp;
    },
    

    login: async function(context, payload) {
      console.log('action login', payload);
      
      context.commit('SET_CONNECTION_ID', '');
      context.commit('SET_LOGIN_STATE', false);

      try {
        let resp=await apiclient.login(payload.email, payload.myid_token);
        console.log(resp);
        if (resp.token) {
          context.commit('SET_CONNECTION_ID', resp.token);
          context.commit('SET_LOGIN_STATE', true)
          return true;  
        } else {
          return resp;
        }
      } catch(err) {
        console.log('login failed');
        return false;
      }
    },
    validate_login: async function(context) {
      console.log('test_validate');
      
      try {
        let resp=await apiclient.validate(context.getters.connection_id);
        console.log(resp);
        context.commit('SET_CONNECTION_ID', resp.token);
        context.commit('SET_LOGIN_STATE', true)
        return true;
      } catch(err) {
        console.log('login failed');
        console.log(err);
        
        return false;
      }
      
    },
    getConfigFromMeta: async function(context) {

      if (context.getters.config.database) {
        console.log('getConfigFromMeta: configuration alrady present, skipped');        
        return;
      }

      context.commit('SET_BUSY', true);
      
      try {
        let resp=await apiclient.getmeta(context.getters.connection_id);
        console.log(resp);
        context.commit( 'SET_GLOBAL_CONFIG', resp );

        context.commit('SET_BUSY', false);
        return resp;

      } catch(err) {
        console.log('getConfigFromMeta failed');
        console.log(err);
        
        context.commit('SET_BUSY', false);
        return false;
      }
      
    },
    /*
        {
          "total": 1,
          "results": [
            {
              "id": "59621911167",
              "properties": {
                "hs_createdate": "2024-09-05T06:16:18.738Z",
                "hs_lastmodifieddate": "2024-09-05T06:16:18.738Z",
                "hs_object_id": "59621911167"
              },
              "createdAt": "2024-09-05T06:16:18.738Z",
              "updatedAt": "2024-09-05T06:16:18.738Z",
              "archived": false
            }
          ]
        }
    */
    // risolvere i valori dinamici dei filtri (lookup a campi non ancora salvati)
    resolveFilterValues: function(context, payload) {
      const { filters, record } = payload;
      
      if (!filters || !Array.isArray(filters)) return filters;
      
      return filters.map(filter => {
        if (filter.recordField) {
          let value = null;
          
          // 1. Prima prova a prendere dal record passato (se esiste)
          if (record && record[filter.recordField] !== undefined) {
            value = record[filter.recordField];
          }
          // 2. Poi prova a prendere da getRecordData (record salvato)
          else if (context.getters.getRecordData && context.getters.getRecordData[filter.recordField] !== undefined) {
            value = context.getters.getRecordData[filter.recordField];
          }
          // 3. Infine prova a prendere dai campi modificati ma non salvati
          else {
            const currentFormData = context.state.records_data[context.state.global_state_process];
            if (currentFormData && currentFormData[filter.recordField] !== undefined) {
              value = currentFormData[filter.recordField];
            }
          }
          
          console.log(`DEBUG - Resolved filter ${filter.recordField}:`, value);
          
          return {
            ...filter,
            value: value
          };
        }
        return filter;
      });
    },
    

    load_records: async function(context, payload) {
      console.log('load_records', payload);

      let p=[];
      console.log(payload.cols);
      payload.cols.forEach( f => {
        if (f.fieldname!='id') p.push(f.fieldname);
      });

      let record = (payload.overrideRecord) ? payload.overrideRecord : context.getters.getRecordData;
  
      if (payload.filters) {
        payload.filters = await context.dispatch('resolveFilterValues', {
          filters: payload.filters,
          record: record
        });
      }

      let res=await context.dispatch('search_records', { id: payload.id, object: payload.tablename, properties:p, filters: payload.filters, orders: payload.orders, groups: payload.groups, offset: payload.offset, limit: payload.limit, childQuery: payload.childQuery });

      return res;
    },

    signInWithProvider: function (context, data) {
      return new Promise(function (resolve) {
        
        apiclient.loginWithProvider(context.state.connection, data).then(function (resp) {
          console.log(resp)
          resolve(resp);
        });
      });
    },
    load_query: async function(context, payload) {
      console.log('load_query', payload);
      context.commit('SET_BUSY', true);
      // Sostituzione automatica $User.Id
      if (payload.filters) {
        payload.filters = replaceUserIdInFilters(payload.filters, context.state.userid);
      }
      if (payload.childQuery) {
        payload.childQuery = payload.childQuery.map(cq => {
          if (cq.filters) cq.filters = replaceUserIdInFilters(cq.filters, context.state.userid);
          return cq;
        });
      }
      try {
        let resp=await apiclient.query(context.getters.connection_id, payload, {key: context.state.overrideKey, user: context.state.overrideUser, account: context.state.overrideAccount} );
        console.log(resp);

        if(resp.error) {
          console.log('ERRORE: '+resp.error[0].errorCode+': '+resp.error[0].message)
          context.dispatch('showError', { error: resp.error })
          return false
        }

        if (resp && resp.data) {
          context.commit('SET_QUERY_RECORDS', resp.data );
        }
        context.commit('SET_BUSY', false);
        return resp;
      } catch(err) {
        console.log('search_records failed', payload);
        console.log(err);
        
        context.commit('SET_BUSY', false);
        return false;
      }
    },

    search_records: async function(context, payload) {
      console.log('search_records', payload);
      context.commit('SET_BUSY', true);
      // Sostituzione automatica $User.Id
      if (payload.filters) {
        payload.filters = replaceUserIdInFilters(payload.filters, context.state.userid);
      }
      if (payload.childQuery) {
        payload.childQuery = payload.childQuery.map(cq => {
          if (cq.filters) cq.filters = replaceUserIdInFilters(cq.filters, context.state.userid);
          return cq;
        });
      }
      try {
        let resp=await apiclient.search(context.getters.connection_id, payload.object, payload.properties, payload.filters, payload.orders, payload.groups, payload.offset, payload.limit, payload.childQuery, {key: context.state.overrideKey, user: context.state.overrideUser, account: context.state.overrideAccount} );
        console.log("stiamo cercando questo : ",resp);

        if(resp.error) {
          console.log('ERRORE: '+resp.error[0].errorCode+': '+resp.error[0].message)
          context.dispatch('showError', { error: resp.error })
          return false
        }

        if (resp && resp.data.records) {
          for(var r of resp.data.records) {
            r['show'] = true
          }
          // TODO: hubspot version for totals and pagination
          context.commit('SET_RECORDS_LIST', {id: payload.id, data: { records: resp.data.records, totalRecords: resp.data.totalSize, complete: resp.data.done, nextPage: resp.data.nextRecordsUrl } });
        }
        context.commit('SET_BUSY', false);
        return resp;

      } catch(err) {
        console.log('search_records failed', payload);
        console.log(err);
        
        context.commit('SET_BUSY', false);
        return false;
      }
      
    },
    locate_records: async function(context, payload) {
      console.log('locate_records', payload);
      context.commit('SET_BUSY', true);
      
      try {
        let resp=await apiclient.locate(context.getters.connection_id, payload.querystring, payload.objsQueryString );
        console.log(resp);

        if(resp.error) {
          console.log('ERRORE: '+resp.error[0].errorCode+': '+resp.error[0].message)
          context.dispatch('showError', { error: resp.error })
          return false
        }
        if(resp && resp.data && resp.data.searchRecords) {
          resp = resp.data.searchRecords
          var labels = {
            "Account": "Customer",
            "Opportunity": "Project",
            "Product2": "Product"
          }
          resp.forEach( r => {
            if(labels[r.attributes.type]) r.attributes['label'] = labels[r.attributes.type]
            else r.attributes['label'] = r.attributes.type
          })
        }
        
        context.commit('SET_BUSY', false);
        return resp;

      } catch(err) {
        console.log('locate_records failed', payload);
        console.log(err);
        
        context.commit('SET_BUSY', false);
        return false;
      }
      
    },
    retrieve_record: async function(context, payload) {
      console.log('retrieve_record', payload);
      context.commit('SET_BUSY', true);
      
      try {
        let resp=await apiclient.retrieve(context.getters.connection_id, payload.object, payload.recordId, payload.properties, payload.associations, {key: context.state.overrideKey, user: context.state.overrideUser, account: context.state.overrideAccount});
        console.log('retrieve_record',resp);

        if(resp.error) {
          console.log('ERRORE: '+resp.error[0].errorCode+': '+resp.error[0].message)
          context.dispatch('showError', { error: resp.error })
          context.commit('SET_RECORDS_DATA', { id: payload.id, data:{} });
          return false
        }

        if (resp) {
          context.commit( 'SET_RECORDS_ID', { id: payload.id, data:resp.data.Id });
          context.commit( 'SET_RECORDS_DATA', { id: payload.id, data:resp.data });
          // context.commit( 'SET_RECORDS_STATE', { id: payload.id, state:'READY' });
          
          /* vabbè andava e l'ho rotto TODO: SET_RECORDS_ASSOC
          if (resp.data.associations) {
            for (let assoc in resp.data.associations) {
              let ids=[];
              resp.data.associations[assoc].results.forEach( (r) => {
                ids.push({ "id":r.id, "type": r.type });
              })
              context.commit('SET_RECORDS_ASSOC', { table: assoc, data:ids} );
            }
          }
          */
        } else context.commit('SET_RECORDS_DATA', { id: payload.id, data:{} });
        
        context.commit('SET_BUSY', false);
        return resp;

      } catch(err) {
        console.log('search_records failed', payload);
        console.log(err);
        context.commit('SET_BUSY', false);
        
        return false;
      }
      
    },
    batchread_records: async function(context, payload) {
      console.log('batchread_records', payload);
      context.commit('SET_BUSY', true);
      
      try {
        let resp=await apiclient.batchread(context.getters.connection_id, payload.object, payload.recordIds, payload.properties);

        if(resp.error) {
          console.log('ERRORE: '+resp.error[0].errorCode+': '+resp.error[0].message)
          context.dispatch('showError', { error: resp.error })
          return false
        }

        console.log(resp);
        if (resp) {
          context.commit('SET_RECORDS_LIST', {id: payload.id, data: resp.data });
          context.commit('SET_BUSY', false);
        }
        return resp;

      } catch(err) {
        console.log('search_records failed', payload);
        console.log(err);
        context.commit('SET_BUSY', false);
        
        return false;
      }
    },
    hydrate_records: async function(context, payload) {
      console.log('hydrate_records', payload);
      context.commit('SET_BUSY', true);

      let records=context.getters.getRecords(payload.id);
      let ids=[];
      records.forEach((r) => {
        ids.push(r.id);
      })
      try {
        let resp=await apiclient.batchread(context.getters.connection_id, payload.object, ids, payload.properties);
        console.log(resp);
        if (resp) {
          context.commit('SET_RECORDS_LIST', {id: payload.id, data: resp.data });
          context.commit('SET_BUSY', false);
        }
        return resp;

      } catch(err) {
        console.log('hydrate_records failed', payload);
        console.log(err);
        context.commit('SET_BUSY', false);
        
        return false;
      }
    },
    get_content_body: async function(context, payload) {
      console.log('get_content_body', payload);
      context.commit('SET_BUSY', true);
      
      try {
        let resp = await apiclient.getcontentbody(context.getters.connection_id, payload.uri);
        return resp;
      }catch(err) {
        console.log('get_content_body failed', payload);
        console.log(err);
        return false;
      }finally {
        context.commit('SET_BUSY', false);
      }
    },
    create_record: async function(context, payload) {
      console.log('create_record', payload);
      context.commit('SET_BUSY', true);
      
      try {
        let resp=await apiclient.create(context.getters.connection_id, payload.object, payload.properties);
        console.log('index.js create_record resp',resp);

        if(resp && resp.error) {
          const alertText = Array.isArray(resp.error)
            ? resp.error.map(e => `[${e.errorCode}] ${e.message}`).join('\n')
            : (resp.error.message || String(resp.error));
          //alert(alertText);
          console.log('ERRORE: '+resp.error[0].errorCode+': '+resp.error[0].message)
          context.dispatch('showError', { error: resp.error })
          context.commit('SET_BUSY', false);
          return false
        }

        if (resp) {
          if (!payload.notUpdateRecord) context.commit('SET_FIELD_VALUE', { fieldname: 'Id', fieldvalue: resp.data.id} );
          if (!resp.success)  context.commit('SET_RECORD_ERRORS', { errors: resp.errors} );
//          context.commit('SET_RECORDS_LIST', {id: payload.id, data: resp.data });
          context.commit('SET_BUSY', false);
        }
        return resp;

      } catch(err) {
        console.log('create_record failed', payload);
        console.log(err);
        context.commit('SET_BUSY', false);
        
        return false;
      }
    },

    create_records: async function(context, payload) {
      console.log('create_records', payload);
      context.commit('SET_BUSY', true);
      
      try {
        let resp=await apiclient.create(context.getters.connection_id, payload.object, payload.properties);
        console.log('index.js create_record resp',resp);

        if(resp.error) {
          console.log('ERRORE: '+resp.error[0].errorCode+': '+resp.error[0].message)
          context.dispatch('showError', { error: resp.error })
          return false
        }

        if (resp) {
          context.commit('SET_FIELD_VALUE', { fieldname: 'Id', fieldvalue: resp.data.id} );
          if (!resp.success)  context.commit('SET_RECORD_ERRORS', { errors: resp.errors} );
//          context.commit('SET_RECORDS_LIST', {id: payload.id, data: resp.data });
          context.commit('SET_BUSY', false);
        }
        return resp;

      } catch(err) {
        console.log('create_record failed', payload);
        console.log(err);
        context.commit('SET_BUSY', false);
        
        return false;
      }
    },
    
    update_record: async function(context, payload) {
      console.log('update_record', payload);
      context.commit('SET_BUSY', true);
      
      try {
        let resp=await apiclient.update(context.getters.connection_id, payload.object, payload.recordId, payload.properties);
        console.log('index.js update_record resp',resp);

        if(resp && resp.error) {
          const alertText = Array.isArray(resp.error)
            ? resp.error.map(e => `[${e.errorCode}] ${e.message}`).join('\n')
            : (resp.error.message || String(resp.error));
          alert(alertText);
          console.log('ERRORE: '+resp.error[0].errorCode+': '+resp.error[0].message)
          context.dispatch('showError', { error: resp.error })
          context.commit('SET_BUSY', false);
          return false
        }
        
        if (resp) {
//          context.commit('SET_RECORDS_LIST', {id: payload.id, data: resp.data });
          context.commit('SET_BUSY', false);
        }
        return resp;

      } catch(err) {
        console.log('update_record failed', payload);
        console.log(err);
        context.commit('SET_BUSY', false);
        
        return false;
      }
    },
    delete_record: async function(context, payload) {
      console.log('delete_record', payload);
      context.commit('SET_BUSY', true);
      
      try {
        let resp=await apiclient.delete(context.getters.connection_id, payload.object, payload.recordId, payload.microsoftId__c, payload.eventBody);
        console.log('index.js delete_record resp',resp);

        if(resp.error) {
          console.log('ERRORE: '+resp.error[0].errorCode+': '+resp.error[0].message)
          context.dispatch('showError', { error: resp.error })
          return false
        }
        
        if (resp) context.commit('SET_BUSY', false);
        return resp;

      } catch(err) {
        console.log('delete_record failed', payload);
        console.log(err);
        context.commit('SET_BUSY', false);
        
        return false;
      }
    },

    queryInvoiceFile: async function(context, payload) {
      context.commit('SET_BUSY', true)
      let resp = await apiclient.queryfileinvoice(context.getters.connection_id, payload);
      console.log("queryFile", resp);
      context.commit('SET_BUSY', false)
      return resp;
    },

    showError: function(context, payload) {
      console.log('error message shown');
      let error = payload.error
      let errList = []
      error.forEach( e => {
        errList.push(e.message)
        if (window.OpenReplay) window.OpenReplay.issue('alert_error', { code: e.errorCode, message: e.message })
      })
      alert(errList)
      context.commit('SET_BUSY', false);
    },
    logout: function(context) {
      console.log('User signed out.');
      localStorage.removeItem('salespaddy_id');
      context.commit('SET_CONNECTION_ID', '');
      context.commit('SET_LOGIN_STATE', false);
    },
    getConfigFromDB: async function(context) {
      // console.log("context: :" + console.log("context: " + JSON.stringify(context)))
      context.commit('SET_BUSY', true);
      //chiamata ad apiclient
      const data = await apiclient.getConfig(context.getters.connection_id);
      // console.log("data database :"+ data)
      //Commit per aggiornare lo stato globale con i dati ricevuti
      context.commit('SET_GLOBAL_CONFIG', data);
      
      context.commit('SET_BUSY', false);

    },
    getConfigFromStorage: async function(context) {
      console.log('index getConfigFromStorage')
      context.commit('SET_BUSY', true);
      const data = await apiclient.convert(context.getters.connection_id, localStorage.getItem('config'));
      context.commit('SET_GLOBAL_CONFIG', data);
      context.commit('SET_BUSY', false);
    },
    setObjectDB: async function(context, payload) {
      context.commit('SET_BUSY', true);
      console.log("payload of object props send: ", payload);  // Log completo
    
     
      //console.log('id__c', payload.id, 'props',payload.props.data);
      
      const result = await apiclient.setObject(context.getters.connection_id, payload);


      context.commit('SET_BUSY', false);

      return result;
    },
    //richiede nel payload: id, type.
    createObject: async function(context, payload) {
      context.commit('SET_BUSY', true);
      console.log("payload of object props create: ",payload);  // Log completo
    
     
      //console.log('id__c', payload.id, 'props',payload.props.data);
      
      const result = await apiclient.createObject(context.getters.connection_id, payload);


      context.commit('SET_BUSY', false);

      return result;
    },
    deleteObject: async function(context, payload){
      context.commit('SET_BUSY', true);
      console.log(payload, " delete object");
      const result = await apiclient.toDelete(context.getters.connection_id, payload);



      context.commit('SET_BUSY', false);
      return result;
    },
    getObjectFromDB: async function(context, payload){
      context.commit('SET_BUSY', true);
      //chiamata ad apiclient
      console.log("entro nel router");
      const data = await apiclient.getObject(context.getters.connection_id, payload);
      //Commit per aggiornare lo stato globale con i dati ricevuti
      console.log(data);
      let nmPayload={ id: data.id, cfg: data };    
      context.commit('SET_CONFIG',context, nmPayload);
      context.commit('SET_BUSY', false);

    }, 
    isUsedByDB: async function(context, payload){
      context.commit('SET_BUSY', true);
      
      console.log("recived id by is used DB", payload)

      //await context.dispatch('getObject', payload);
      await context.dispatch('getConfigFromDB');

      await context.getters.isUsed(payload);



      context.commit('SET_BUSY', false);

    }, 
    getHousings: async function(context, payload){
      context.commit('SET_BUSY', true);


      const data = await apiclient.getHousings(context.getters.connection_id, payload);
      console.log(data, " get housing index");
      context.commit('UPDATE_CONFIG_OBJECTS', data);
      console.log("end of get housing ");
      context.commit('SET_BUSY', false);

    },
    switchEditProps: function(context){
      const newStatus = !context.getters.getEditProps
      context.commit('SET_EDIT_PROPS', newStatus);
    },
    subscribeNotifications: async function(context, payload){
      context.commit('SET_BUSY', true);
      const data = await apiclient.subscribeNotifications(context.getters.connection_id, payload);
      console.log("subscribeNotifications data: ", data);
      console.log("end of saveSubscription ");
      context.commit('SET_BUSY', false);
    },
    getNotificationsPublicKey: async function (context, payload) {
      console.log("[STORE] [INFO] getNotificationsPublicKey");
      try {
        const resp = await apiclient.getNotificationsPublicKey();
        
        console.log("[STORE] [SUCCESS] getNotificationsPublicKey", resp);
        return resp;
      } catch (err) {
        console.error("[STORE] [ERROR] getNotificationsPublicKey:", err);
        throw err;
      }
    },
    create_content_version: async function(context, payload) {
      console.log('create_content_version', payload);
      context.commit('SET_BUSY', true);
      
      try {
        let resp=await apiclient.createcontentversion(context.getters.connection_id, payload);
        console.log('index.js create_content_version resp',resp);

        if(resp.error) {
          console.log('ERRORE: '+resp.error[0].errorCode+': '+resp.error[0].message)
          context.dispatch('showError', { error: resp.error })
          return false
        }
        
        if (resp) context.commit('SET_BUSY', false);
        return resp;

      } catch(err) {
        console.log('create_content_version failed', payload);
        console.log(err);
        context.commit('SET_BUSY', false);
        
        return false;
      }
    },
    getNotificationFromDB: async function(context, payload){
      context.commit('SET_BUSY', true);
      let toSend = {
        contactId: context.state.myprofile.contactId
      };

      // if (!toSend.contactId && context.getters.connection_id) {
      //   console.log('getNotificationFromDB need myprofile');
      //   toSend.contactId = (await context.dispatch('myprofile')).myprofile.contactId;
      // }

      var returnedValue
      try {
        returnedValue = await apiclient.getNotification(context.getters.connection_id, toSend);
        console.log("--> getNotificationFromDB --> data: ", JSON.stringify(returnedValue));
      } catch(e) {
        console.warn('NO notifications')
      }

      if(returnedValue && returnedValue.data && returnedValue.data.length){
        // let notification = returnedValue.data.map(obj => JSON.parse(obj.Description));
        const notification = returnedValue.data.map(record => ({
          url: record.notificationUrl__c,
          title: record.Subject,
          body: record.Description,
          Id: record.Id
        }));
        
        console.log("--> getNotificationFromDB --> notification: ", notification);
        context.commit('SET_NOTIFICATIONS', notification);
      }
      if ('serviceWorker' in navigator && !context.state.hasNotificationListener) {

        navigator.serviceWorker.addEventListener('message', (event) => {
          if (event.data && event.data.type === "PUSH_NOTIFICATION") {
            console.log("Global Vuex Listener caught push:", event.data.data);
            context.commit("PUSH_NOTIFICATION", event.data.data); 
          }
        });

        context.commit('SET_LISTENER_FLAG', true);
      }
      context.commit('SET_BUSY', false);
    },
    getPDFproject: async function(context, configJson) {
      console.log('getPDFproject');

      var r = context.getters.getRecordData
      let resp = await Promise.all([
        // products
        context.dispatch('search_records', 
          { 
            id: '', 
            object: 'OpportunityLineItem', 
            properties: [ 'Product2.ProductCode', 'Product2.Family', 'Product2.Sales_brand_name__c', 
              'Product2.Color_name__c', 'Product2.Shape__c', 'Product2.UoM_sale__c',
              'Quantity', 'ListPrice', 'TotalPrice', 'UnitPrice' ], 
            filters: [
              {"fieldname": "OpportunityId", "operator": "EQ", "value": r.Id }
            ], 
            orders: [], groups: [], offset: 0, limit: 200, childQuery: []
          }
        ),
        // players
        context.dispatch('search_records', 
          { 
            id: '', 
            object: 'Project_player__c', 
            properties: [ 'Role__c', 'Account__r.Name', 'Account__r.Phone',
              'Account__r.BillingStreet', 'Account__r.BillingCity', 'Account__r.BillingState', 'Account__r.BillingPostalCode',
              'Account__r.Email__c', 'Account__r.Fax__c'
              ], 
            filters: [
              {"fieldname": "Project__c", "operator": "EQ", "value": r.Id },
              // {"fieldname": "Role__c", "operator": "EQ", "value": 'Architect' },
            ], 
            orders: [], groups: [], offset: 0, limit: 200, childQuery: []
          }
        ),
        // approval history
        context.dispatch('search_records', 
          { 
            id: '', 
            object: 'OpportunityFieldHistory', 
            properties: [ 'NewValue', 'CreatedDate', 'Opportunity.SalesPaddy_Approver__r.Name', 'Opportunity.SalesPaddy_Approver__r.Business_Role__r.Name' ], 
            filters: [
              { "fieldname": "Field", "operator": "EQ", "value": "Approval_status__c" },
              { "fieldname": "OpportunityId", "operator": "EQ", "value": r.Id }
            ], 
            orders: [
              { "fieldname": "CreatedDate", "operator": "DESC" }
            ],
            groups: [], offset: 0, limit: 200, childQuery: []
          }
        )
      ]);

      console.log('products',resp[0]);
      console.log('players',resp[1])
      console.log('approval history',resp[2])

      if(resp.error) {
        console.log('ERRORE: '+resp.error[0].errorCode+': '+resp.error[0].message)
        context.dispatch('showError', { error: resp.error })
        return 'errore'
      }


      var datiPDF = r

      Object.defineProperties( datiPDF, {
        players: { value: resp[1].data.records },
        products: { value: resp[0].data.records },
        approvalHistory: { value: resp[2].data.records },


        oggi: { value: new Date() },

        currency: { value:  function() {
          return function (text, render) {
            return '$ '+parseFloat(render(text)).toLocaleString("us-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          }
        }},

        date: { value:  function() {
          return function (text, render) {
            return new moment(render(text)).format('DD/MM/YYYY')
          }
        }},

        datetime: { value:  function() {
          return function (text, render) {
            return new moment(render(text)).format('DD/MM/YYYY HH:mm')
          }
        }},

        trim: { value:  function() {
          return function (text, render) {
            return render(text).trim()
          }
        }},

        html: { value:  function() {
          return function (text, render) {
            var doc = new DOMParser().parseFromString(render(text), "text/html");
            return doc.documentElement.textContent;
          }
        }},

      })

      console.log('datiPDF', datiPDF)
      
      configJson = configJson.replaceAll(/'/g, '"')
      // console.log('configJson', configJson)

      var output = mustache.render(configJson, datiPDF)
      // console.log('output 1', output)
      output = output.replaceAll(/],]/g, ']]')
      console.log('output 2', output)

      var filebody = await context.dispatch('generatePdf', JSON.parse(output))
      return filebody
    },
    generatePdf: async function (context, payload) {
      try {
        var base64 = await apiclient.generatePdf(payload)

        if(base64.error) {
          console.log('ERRORE: '+base64.error[0].errorCode+': '+base64.error[0].message)
          context.dispatch('showError', { error: base64.error })
          return false
        }

        console.log('base64',base64)
        console.log('base64.data.pdfBody',base64.data.pdfBody)
        return base64.data.pdfBody
      } catch(err) {
        console.log('generatePdf failed', payload);
        console.log(err);
        return false;
      }
    },
    getPDF: async function(context, data) {
      console.log('getPDF', data);
      var configJson = data.config

      var r = context.getters.getRecordData

      var datiPDF = r

      for(var q of data.table) {
        q.filters.push( { "fieldname": q.parent, "operator": "EQ", "value": r.Id } )
        var tmp = await context.dispatch('search_records', q )
        datiPDF[q.object] = tmp.data.records
      }
      console.log('datiPDF', datiPDF)

      Object.defineProperties( datiPDF, {

        oggi: { value: new Date() },

        currency: { value:  function() {
          return function (text, render) {
            if(!render(text)) return '$ 0'
            return '$ '+parseFloat(render(text)).toLocaleString("us-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          }
        }},

        date: { value:  function() {
          return function (text, render) {
            return new moment(render(text)).format('DD/MM/YYYY')
          }
        }},

        

        datetime: { value:  function() {
          return function (text, render) {
            return new moment(render(text)).format('DD/MM/YYYY HH:mm')
          }
        }},

        trim: { value:  function() {
          return function (text, render) {
            return render(text).trim()
          }
        }},

        html: { value:  function() {
          return function (text, render) {
            var doc = new DOMParser().parseFromString(render(text), "text/html");
            return doc.documentElement.textContent;
          }
        }},

      })

      console.log('datiPDF', datiPDF)
      
      configJson = configJson.replaceAll(/'/g, '"')
      // console.log('configJson', configJson)

      var output = mustache.render(configJson, datiPDF)
      // console.log('output 1', output)
      output = output.replaceAll(/],]/g, ']]')
      console.log('output 2', output)

      var filebody = await context.dispatch('generatePdf', JSON.parse(output))
      return filebody
    },
    loginToken: async function (context, payload) {
      console.log('loginToken', payload);
      try {
        let resp = await apiclient.loginToken(payload);
        console.log('loginToken response:', resp);
        return resp
      } catch (err) {
        console.log('loginToken failed', payload);
        console.log(err);
        context.dispatch('showError', { error: [{ message: "loginToken failed. The link may be expired." }] });
        return false;
      }
    },
  }
})
